export enum NewFeatures {
  mass_assign = "ATS: Mass Assign",
  reporting_tab = "Sidebar: Reporting tab",
  reporting_ats_disqualification_new_filter = "Reporting: Disqualification new filters",
  reporting_ats_stage_flow_candidates_export = "Reporting: Stage flow candidates export",
  ats_stage_flow_funnel = "ATS: Stage flow funnel",
  employee_edit_menu = "Employee: Edit menu",
  employee_saved_views = "Employee: Saved views",
  employee_termination_in_actions = "Employee: Termination in actions",
  event_time_minute_precision = "Calendar: Event time minute precision",
}
